import {
  parsePhoneNumberWithError,
  validatePhoneNumberLength,
  type CountryCode,
} from "libphonenumber-js";

export const removeUnnecessaryCharactersFromPhone = (phone: string): string => {
  phone = phone.replace(/[^0-9+]/g, "");
  return phone;
};

const getCountrySpecificErrorMessage = (phone: string): string => {
  if (phone.startsWith("+61")) {
    return "Please use a valid Australian phone number";
  }
  return "Please use a valid US or Canadian phone number";
};

/**
 * Validates a phone number for US, Canadian, or Australian format.
 * @returns null if valid, error message string if invalid.
 */
export const phoneValidator = (phone: string): string | null => {
  phone = phone.trim();

  if (!phone || phone.length === 0) {
    return "Please enter a phone number";
  }

  try {
    const defaultCountry: CountryCode = phone.startsWith("+61") ? "AU" : "US";
    const phoneNumber = parsePhoneNumberWithError(phone, defaultCountry);

    if (!phoneNumber) {
      return getCountrySpecificErrorMessage(phone);
    }

    const allowedCountries = ["US", "CA", "AU"];
    if (!allowedCountries.includes(phoneNumber.country || "")) {
      return getCountrySpecificErrorMessage(phone);
    }

    if (!phoneNumber.isValid()) {
      return getCountrySpecificErrorMessage(phone);
    }

    const lengthValidation = validatePhoneNumberLength(
      phone,
      phoneNumber.country,
    );
    if (lengthValidation) {
      switch (lengthValidation) {
        case "TOO_SHORT":
          return "Phone number is too short";
        case "TOO_LONG":
          return "Phone number is too long";
        default:
          return getCountrySpecificErrorMessage(phone);
      }
    }

    return null;
  } catch {
    return getCountrySpecificErrorMessage(phone);
  }
};

export const canadaPhoneValidator = phoneValidator;
